import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Hiba történt');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 relative overflow-hidden">
      {/* Háttér dekoráció */}
      <div className="absolute inset-0 opacity-5 pointer-events-none select-none text-8xl flex flex-wrap gap-8 p-8 overflow-hidden">
        {Array.from({ length: 40 }).map((_, i) => (
          <span key={i}>{['🃏','🎰','🎲','♠','♥','♦','♣'][i % 7]}</span>
        ))}
      </div>

      <div className="card w-full max-w-sm mx-4 relative z-10">
        <h1 className="text-2xl font-bold text-center mb-1">
          <span className="text-yellow-400">Csaba</span>Casino
        </h1>
        <p className="text-slate-400 text-center text-sm mb-6">Jelentkezz be a játékhoz</p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg px-3 py-2 text-sm mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-slate-400 mb-1">Felhasználónév</label>
            <input
              className="input"
              type="text"
              autoComplete="username"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-1">Jelszó</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          <button className="btn-gold w-full" type="submit" disabled={loading}>
            {loading ? 'Bejelentkezés...' : 'Bejelentkezés'}
          </button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-4">
          Nincs fiókod?{' '}
          <Link to="/register" className="text-yellow-400 hover:underline">Regisztrálj</Link>
        </p>
      </div>
    </div>
  );
}
